export default "__VITE_ASSET__a8c57414__"